module.exports = __webpack_public_path__ + "img/40_01_013_257.f7e0b4b2.jpg";